import { logWrapper } from '../../utils';
import swal from 'sweetalert2';

export default {
  signDocumentsD4sController: [
    'runtimeConstant',
    '$scope',
    '$timeout',
    '$filter',
    '$location',
    'revisions',
    'authService',
    'signDocumentD4sService',
    function (
      runtimeConstant,
      $scope,
      $timeout,
      $filter,
      $location,
      revisions,
      authService,
      service
    ) {
      'use strict';

      function load() {
        service.d4sGetAllSignersSugestion().then((data) => {
          data.forEach(function (doc) {
            $scope.emailType.push(doc.email);
          });
        });
      }

      function autocomplete() {
        var inp = document.getElementById('{{row}}');
        var arr = $scope.emailType;

        var currentFocus;

        inp.addEventListener('input', function () {
          var val = this.value;

          closeAllLists();

          if (!val) {
            return false;
          }
          currentFocus = -1;

          var a = document.createElement('DIV');
          a.setAttribute('id', this.id + 'autocomplete-list');
          a.setAttribute('class', 'autocomplete-items');

          this.parentNode.appendChild(a);

          for (var i = 0; i < arr.length; i++) {
            if (
              arr[i].substr(0, val.length).toUpperCase() === val.toUpperCase()
            ) {
              var b = document.createElement('DIV');

              b.innerHTML =
                '<strong>' + arr[i].substr(0, val.length) + '</strong>';
              b.innerHTML += arr[i].substr(val.length);

              b.innerHTML += '<input type=\'hidden\' value=\'\' + arr[i] + \'\'>';

              b.addEventListener('click', function () {
                inp.value = this.getElementsByTagName('input')[0].value;

                closeAllLists();
              });
              a.appendChild(b);
            }
          }
        });

        inp.addEventListener('keydown', function (e) {
          var x = document.getElementById(this.id + 'autocomplete-list');
          if (x) x = x.getElementsByTagName('DIV');
          if (e.keyCode === 40) {
            currentFocus++;

            addActive(x);
          } else if (e.keyCode === 38) {
            currentFocus--;

            addActive(x);
          } else if (e.keyCode === 13) {
            e.preventDefault();
            if (currentFocus > -1) {
              if (x) x[currentFocus].click();
            }
          }
        });
        function addActive(x) {
          if (!x) return false;
          removeActive(x);
          if (currentFocus >= x.length) currentFocus = 0;
          if (currentFocus < 0) currentFocus = x.length - 1;
          x[currentFocus].classList.add('autocomplete-active');
        }
        function removeActive(x) {
          for (var i = 0; i < x.length; i++) {
            x[i].classList.remove('autocomplete-active');
          }
        }
        function closeAllLists(elmnt) {
          var x = document.getElementsByClassName('autocomplete-items');
          for (var i = 0; i < x.length; i++) {
            if (elmnt !== x[i] && elmnt !== inp) {
              x[i].parentNode.removeChild(x[i]);
            }
          }
        }
        document.addEventListener('click', function (e) {
          closeAllLists(e.target);
        });
      }

      function initSign() {
        $scope.isSucess = false;
        $scope.isError = false;
        $scope.isSignSucess = false;
        if (revisions === null) {
          $scope.isScopeNoEmbed = false;
        } else {
          $scope.isScopeNoEmbed = false;

          revisions.forEach((element) => {
            $scope.docSign = element;
          });

          var d4SignDocument = $scope.docSign.d4SignDocument;
          if (d4SignDocument !== undefined) {
            if (d4SignDocument.Status === 'Cancelado') {
              $scope.tab = 1;
              $scope.idDocD4Sign = '';
              $scope.statusDocD4Sign = 0;
              $scope.isDocD4s = false;
            } else {
              $scope.tab = 2;
              $scope.isScopeEmbed = true;
              $scope.isD4SignLoad = true;
              $scope.isSignedD4s = false;
              $scope.isDocD4s = true;

              var idRevision = $scope.docSign['id'];
              service.d4sGetSignatories(idRevision).then(
                function (response) {
                  $scope.idDocD4Sign = response.uuidDoc;
                  $scope.statusDocD4Sign = 8;

                  $timeout(changeD4SignLoad, 2000);
                  if (
                    response.list.some(
                      (email) => email.email === $scope.loggedUser.email
                    )
                  ) {
                    renderEmbedD4Sign($scope.idDocD4Sign, $scope.loggedUser);
                  } else {
                    $scope.closeModal();
                    swal.fire({
                      title: 'Documento enviado aos signatários',
                      text: 'Documento aguardando assinaturas',
                      showConfirmButton: true,
                      allowEscapeKey: false,
                      allowOutsideClick: false,
                      icon: 'success',
                    });
                  }
                },
                function () {
                  $scope.closeModal();
                  swal.fire({
                    title: 'Ocorreu um erro ao enviar documento para a D4Sign',
                    text: 'Verifique os status de sua conta D4Sign',
                    showConfirmButton: true,
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    icon: 'error',
                  });
                }
              );
            }
          } else {
            $scope.tab = 1;
            $scope.idDocD4Sign = '';
            $scope.statusDocD4Sign = 0;
            $scope.isSignInActions = true;
            $scope.isDocD4s = false;
          }
        }
        $scope.signatories = [];
      }

      function initDocumentDetails() {
        $scope.isSucess = false;
        $scope.isError = false;
        $scope.isAddSignatories = false;
        $scope.isShowStatus = true;

        var listSigners = $scope.d4sDocumentDetails.list;
        var listTemporary = [];
        var retorno = listSigners.findIndex((it) => it.signed === '0');
        $scope.deleteMail = listSigners.length > 1 ? true : false;
        if (retorno === -1) $scope.isDocSigned = true;
        listSigners.forEach((it) => {
          var status = it.signed !== 0 ? 'Assinou' : 'Pendente';
          listTemporary.push({
            email: it.email,
            status: status,
            signed: it.signed,
          });
        });
        $scope.d4sSigerList = listTemporary;
        $scope.d4signNameDoc = $scope.d4sDocumentDetails.nameDoc;
      }

      function addRow() {
        $scope.rows.push($scope.rows.length);
      }

      function scrollElement() {
        var tabElement = document.getElementById('overflow');
        var saveButton = document.getElementById('saveSignersButton');

        if (
          tabElement.offsetHeight >= 300 &&
          !tabElement.classList.contains('overflow')
        ) {
          saveButton.classList.add('full-btn');
          tabElement.classList.add('overflow');
        }

        if (
          tabElement.classList.contains('overflow') &&
          $scope.rows.length < 4
        ) {
          tabElement.classList.remove('overflow');
          saveButton.classList.remove('full-btn');
        }

        var bottomElement = document.getElementById('bottomElement');
        bottomElement.scrollIntoView();
      }

      function removeRow(index, dataModel) {
        if ($scope.rows.length === 1) {
          $scope.isOneSignatory = true;
        } else {
          $scope.isOneSignatory = false;
          $scope.rows.splice(index, 1);
          $scope.signatories.forEach((it, i) => {
            if (it.email === dataModel) {
              $scope.signatories.splice(i, 1);
            }
          });
        }
        $scope.scrollElement();
      }

      function checkMail(value, id) {
        if (IsMailValid(value)) {
          document.getElementById(id).style.borderColor = '#ccc';
        } else {
          document.getElementById(id).style.borderColor = 'red';
        }
      }

      function addValueInput(value) {
        $scope.signatories.push({
          email: value,
        });
      }

      function prevContext() {
        $scope.rows.length = false;
        $scope.isSucess = false;
        $scope.isError = false;
        $scope.isAddSignatories = false;
        $scope.isShowStatus = true;
      }

      function IsMailValid(email) {
        var re =
          /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
        if (!re.test(email)) {
          return false;
        } else {
          return true;
        }
      }

      function sendSingers() {
        $scope.signatories = [];
        var sf = document.getElementsByClassName('signatory-field');
        for (var i = 0; i < sf.length; i++) {
          if (sf[i].value !== '') {
            var rt = $scope.d4sSigerList.findIndex(
              (d4) => d4.email === sf[i].value.toLowerCase()
            );
            if (rt === -1) {
              var r = IsMailValid(sf[i].value);
              if (!r) {
                swal
                  .fire({
                    icon: 'warning',
                    title: 'E-mail Inválido!',
                    text: 'Você digitou um e-mail inválido: ' + sf[i].value,
                  })
                  .then(function (isOk) {
                    if (isOk) {
                      document.getElementById(i).style.borderColor = 'red';
                      $timeout(function () {
                        document.getElementById(i).style.borderColor = '#ccc';
                      }, 10000);
                      document.getElementById(i).focus();
                    }
                  });
                return;
              }
              $scope.signatories.push({
                email: sf[i].value.toLowerCase(),
              });
            }
          }
        }
        $scope.isSucess = false;
        $scope.isError = false;
        if ($scope.signatories !== null && $scope.signatories.length > 0) {
          $scope.rows.length = false;
          var idRevision = $scope.d4SignIdDocument;
          service.updateD4sSignatories(idRevision, $scope.signatories).then(
            function () {
              swal.fire(
                'Adicionado!',
                'Adicionou e-mails com sucesso.',
                'success'
              );
              $scope.isShowStatus = true;
              $scope.isAddSignatories = false;
              reloadPage(idRevision);
            },
            function () {
              swal.fire(
                'Ops...',
                'Ocorreu um erro ao inserir os novos e-mails.',
                'warning'
              );
              $scope.isShowStatus = true;
              $scope.isAddSignatories = false;
            }
          );
        } else {
          swal.fire(
            'Caro usuário!',
            'Não foi informado um e-mail diferente da lista.',
            'warning'
          );
        }
      }

      function updateSignersDocument(value) {
        var d4sSigerList = $scope.d4sSigerList;
        var newListSigners = [];
        d4sSigerList.forEach((signatoryDefault) => {
          if (signatoryDefault.email !== value.email) {
            newListSigners.push({
              email: signatoryDefault.email,
            });
          }
        });

        var idRevision = $scope.d4SignIdDocument;
        service.updateD4sSignatories(idRevision, newListSigners).then();
      }

      function callAlterMail(signer, index) {
        var mail = document.getElementById('input' + index).value.toLowerCase();
        if (signer.email === mail) {
          swal
            .fire({
              icon: 'info',
              title: 'Caro usuário!',
              text: 'Não foi identificado alteração na descrição do e-mail.',
            })
            .then(function (isOk) {
              if (isOk) document.getElementById('input' + index).focus();
            });
        } else {
          var rt = $scope.d4sSigerList.findIndex((d4) => d4.email === mail);
          if (rt === -1) {
            swal
              .fire({
                icon: 'info',
                title: 'Alterar E-mail',
                text:
                  'Deseja realmente alterar o email  ' +
                  signer.email +
                  ' para o novo e-mail: ' +
                  mail +
                  ' ?',
                confirmButtonText: $filter('translate')('YES'),
                cancelButtonText: $filter('translate')('NO'),
                showCancelButton: true,
                confirmButtonColor: '#E34C2B',
              })
              .then(function (isConfirm) {
                if (isConfirm) {
                  $scope.d4SignLoad = true;
                  $timeout(changeD4SignLoad, 200);
                  var idRevision = $scope.d4SignIdDocument;
                  service.alterMailD4s(idRevision, signer.email, mail).then(
                    function () {
                      swal.fire(
                        'Alterado!',
                        'E-mail alterado com sucesso.',
                        'success'
                      );
                      reloadPage($scope.d4SignIdDocument);
                    },
                    function () {
                      swal
                        .fire({
                          title: 'Ops, ocorreu um erro',
                          text: 'Aparentemente você digitou o e-mail errado, verifique a descrição do e-mail e tente novamente.',
                          showConfirmButton: true,
                          allowEscapeKey: false,
                          allowOutsideClick: false,
                          icon: 'error',
                        })
                        .then(function () {
                          document.getElementById('input' + index).focus();
                        });
                    }
                  );
                }
              });
          } else {
            swal
              .fire({
                icon: 'info',
                title: 'Caro usuário!',
                text: 'O e-mail digitado consta na listagem de envio deste documento.',
              })
              .then(function (isOk) {
                if (isOk) document.getElementById('input' + index).focus();
              });
          }
        }
      }

      function callDeleteMail(signer) {
        var delMail = $scope.d4sSigerList.filter((it) => it.signed === '0');
        if (delMail.length === 1) {
          swal
            .fire({
              icon: 'warning',
              title: 'Remover E-mail',
              html:
                'Caso você <b>Remova</b> este email ' +
                signer.email +
                '<br /> do arquivo: ' +
                $scope.d4signNameDoc +
                '. O documento ira atualizar para <b>Finalizado</b> e não poderá mais inserir E-mails. ',
              confirmButtonText: $filter('translate')('YES'),
              cancelButtonText: $filter('translate')('NO'),
              showCancelButton: true,
              confirmButtonColor: '#E34C2B',
            })
            .then(function () {
              service.removeMailD4s($scope.d4SignIdDocument, signer.email).then(
                function () {
                  swal.fire(
                    'Removido!',
                    'E-mail removido com sucesso.',
                    'success'
                  );
                  reloadPage($scope.d4SignIdDocument);
                },
                function () {
                  $scope.isError = true;
                  $scope.closeModal();
                  swal.fire({
                    title:
                      'Ocorreu um erro ao remover o e-mail do documento para a D4Sign',
                    text: 'Verifique os status de sua conta D4Sign',
                    showConfirmButton: true,
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    icon: 'error',
                  });
                }
              );
            });
        } else {
          swal
            .fire({
              icon: 'warning',
              title: 'Remover E-mail',
              html:
                'Deseja realmente <b>Remover</b> o email  ' +
                signer.email +
                ' do<br />documento: ' +
                $scope.d4signNameDoc +
                ' ?',
              confirmButtonText: $filter('translate')('YES'),
              cancelButtonText: $filter('translate')('NO'),
              showCancelButton: true,
              confirmButtonColor: '#E34C2B',
            })
            .then(function () {
              service.removeMailD4s($scope.d4SignIdDocument, signer.email).then(
                function () {
                  swal.fire(
                    'Removido!',
                    'E-mail removido com sucesso.',
                    'success'
                  );
                  reloadPage($scope.d4SignIdDocument);
                },
                function () {
                  $scope.isError = true;
                  $scope.closeModal();
                  swal.fire({
                    title:
                      'Ocorreu um erro ao remover o e-mail do documento para a D4Sign',
                    text: 'Verifique os status de sua conta D4Sign',
                    showConfirmButton: true,
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    icon: 'error',
                  });
                }
              );
            });
        }
      }

      function IsLoggedUser(email) {
        return authService.user.email === email.email;
      }

      function sendSingedDocument() {
        var sf = document.getElementsByClassName('signatory-field');
        for (var i = 0; i < sf.length; i++) {
          if (sf[i].value !== '') {
            var r = IsMailValid(sf[i].value);
            if (!r) {
              swal
                .fire({
                  icon: 'warning',
                  title: 'E-mail Inválido!',
                  text: 'Você digitou um e-mail inválido: ' + sf[i].value,
                })
                .then(function (isOk) {
                  if (isOk) {
                    document.getElementById(i).style.borderColor = 'red';
                    $timeout(function () {
                      document.getElementById(i).style.borderColor = '#ccc';
                    }, 10000);
                    document.getElementById(i).focus();
                  }
                });
              return;
            }
            $scope.signatories.push({
              email: sf[i].value.toLowerCase(),
            });
          }
        }

        var idRevision = $scope.docSign['id'];
        var listSigners = $scope.signatories;

        $scope.tab = 2;
        $scope.isScopeEmbed = true;
        $scope.isD4SignLoad = true;
        $scope.isSignedD4s = false;
        $scope.isDocD4s = true;

        service.docD4sSignature(idRevision, listSigners).then(
          function (response) {
            var uuidDoc = response.uuidDoc;

            if (
              listSigners.some(
                (signer) => signer.email === $scope.loggedUser.email
              )
            ) {
              $timeout(changeD4SignLoad, 2000);
              renderEmbedD4Sign(uuidDoc, $scope.loggedUser);
            } else {
              $scope.closeModal();
              swal.fire({
                title: 'Documento enviado aos signatários',
                text: 'Documento aguardando assinaturas',
                showConfirmButton: true,
                allowEscapeKey: false,
                allowOutsideClick: false,
                icon: 'success',
              });
            }
          },
          function () {
            $scope.isError = true;
            $scope.closeModal();
            swal.fire({
              title: 'Ocorreu um erro ao enviar documento para a D4Sign',
              text: 'Verifique os status de sua conta D4Sign',
              showConfirmButton: true,
              allowEscapeKey: false,
              allowOutsideClick: false,
              icon: 'error',
            });
          }
        );
        $scope.signatories = [];
      }

      function cancelDocument() {
        $scope.isError = false;
        $scope.isSuccess = false;
        swal
          .fire({
            icon: 'warning',
            title: $filter('translate')('CANCEL'),
            html:
              'Deseja realmente <b>Cancelar</b> todas as<br />assinaturas do documento: ' +
              $scope.d4signNameDoc +
              ' ?',
            confirmButtonText: $filter('translate')('YES'),
            cancelButtonText: $filter('translate')('NO'),
            showCancelButton: true,
            confirmButtonColor: '#E34C2B',
          })
          .then(function () {
            var idRevision = $scope.d4SignIdDocument;
            service.docD4sCancel(idRevision).then(
              function () {
                $scope.isShowStatus = false;
                $scope.isSuccess = true;
                $scope.successMessage = 'Documento cancelado com sucesso!';
              },
              function () {
                $scope.isShowStatus = false;
                $scope.isError = true;
                $scope.errorMessage = 'Não foi possivel cancelar o documento!';
              }
            );
          });
      }

      function changeD4SignDetails() {
        $scope.rows.length = true;
        $scope.isShowStatus = false;
        $scope.isAddSignatories = true;
      }

      function modifyDocument() {
        if ($scope.isDocSigned) {
          return false;
        } else {
          if (
            revisions.IdAuthor === authService.user.id ||
            authService.user.isSysAdmin === true ||
            authService.isAdmin() === true
          )
            return true;
          return false;
        }
      }

      function closeModal(option = false) {
        if (option) {
          if ($scope.tokenApi !== null && $scope.cryptKey !== null) {
            if ($scope.$parent && $scope.$parent.currentItem) {
              $scope.$parent.currentItem.tokenApi = null;
              $scope.$parent.currentItem.cryptKey = null;
              $scope.$parent.currentItem.cofre = null;
            } else {
              // eslint-disable-next-line no-console
              console.warn('currentItem não encontrado no $parent');
            }
          }
        }

        $scope.$close();

        if (typeof $scope.loadDocuments === 'function') {
          $scope.loadDocuments();
        } else {
          $location.path('/');
          $location.search('');
        }
      }

      function sendSingerSettings() {
        if ($scope.d4SignTokenApi && $scope.d4SignCriptKey) {
          var credendials = {
            idUser: null,
            tokenApi: $scope.d4SignTokenApi,
            cryptKey: $scope.d4SignCriptKey,
          };

          service.sendD4SignCredendials(credendials).then(
            function () {
              $timeout($scope.$close(), 200);
              authService.loadUser().then(function () {
                swal.fire({
                  title: 'Credenciais Salvas com sucesso',
                  text: 'Credenciais Salvas com sucesso',
                  showConfirmButton: true,
                  allowEscapeKey: false,
                  allowOutsideClick: false,
                  icon: 'success',
                });
                $location.path('/');
                $location.search('');
              });
            },
            function () {
              swal.fire({
                title: 'Falha ao salvar credenciais',
                text: 'Falha ao salvar credenciais',
                showConfirmButton: true,
                allowEscapeKey: false,
                allowOutsideClick: false,
                icon: 'error',
              });
            }
          );
        } else {
          $scope.isError = true;
          $scope.errorMessage = 'Preencha os dados do token API e/ou crypt Key';
        }
      }

      function successSign(option) {
        if (option) {
          $scope.closeModal();
          swal.fire({
            title: 'Documento assinado com sucesso',
            text: 'Documento assinado com sucesso',
            showConfirmButton: true,
            allowEscapeKey: false,
            allowOutsideClick: false,
            icon: 'success',
          });
        } else {
          swal.fire({
            title: 'Erro ao assinar documento',
            text: 'Verifique os status de sua conta D4Sign',
            showConfirmButton: true,
            allowEscapeKey: false,
            allowOutsideClick: false,
            icon: 'error',
          });
        }
      }

      function renderEmbedD4Sign(uuidDoc, signerEmail, signerName = null) {
        d4sign.configure({
          container: 'signature-d4s',
          key: uuidDoc,
          protocol: 'https',
          host: 'secure.d4sign.com.br/embed/viewblob',
          signer: {
            email: signerEmail.email,
            name: signerName,
          },
          width: '450',
          height: '680',
          overflow: 'auto',
          callback: function (event) {
            if (event.data === 'signed') {
              successSign(true);
            }
          },
        });
      }

      function viewEdit(el) {
        if (!$scope.isDocSigned) {
          var rt = $scope.modifyDocument();
          if (rt) {
            var edit = document.getElementsByClassName('boxEdit');
            for (var i = 0; i < edit.length; i++) {
              edit[i].style.display = 'none';
            }
            var view = document.getElementsByClassName('boxView');
            for (var i = 0; i < view.length; i++) {
              view[i].style.display = '';
            }
            document.getElementById('view' + el).style.display = 'none';
            document.getElementById('edit' + el).style.display = '';
            document.getElementById('input' + el).focus();
          }
        }
      }

      function closeEdit(el) {
        document.getElementById('edit' + el).style.display = 'none';
        document.getElementById('view' + el).style.display = '';
      }

      function reloadPage(idRevision) {
        var listTemporary = [];
        var retorno = '';
        $scope.isD4SignLoad = true;
        $scope.isShowStatus = false;
        $scope.d4sSigerList = '';
        service.d4sGetSignatories(idRevision).then(function (response) {
          $scope.d4sDocumentDetails = response;
          $scope.d4SignIdDocument = idRevision;
          $scope.isShowStatus = true;
          retorno = response.list.findIndex((it) => it.signed === '0');
          if (retorno === -1) $scope.isDocSigned = true;
          response.list.forEach((it) => {
            var status = it.signed !== 0 ? 'Assinou' : 'Pendente';
            listTemporary.push({
              email: it.email,
              status: status,
              signed: it.signed,
            });
          });
          $scope.d4sSigerList = listTemporary;
          $scope.deleteMail = response.list.length > 1 ? true : false;
        });
      }

      function callSignRequest(signer) {
        $scope.isScopeEmbed = true;
        $scope.d4SignLoad = true;
        $timeout(changeD4SignLoad, 200);
        renderEmbedD4Sign($scope.UuidDocument, signer);
      }

      function changeD4SignLoad() {
        $scope.isD4SignLoad = false;
      }

      function run() {
        try {
          $scope.isOneSignatory = false;
          $scope.isD4SignLoad = false;
          $scope.isSignedD4s = true;
          $scope.isSingleSignatory = false;
          $scope.isMultipleSignatories = true;
          $scope.loggedUser = authService.user;
          $scope.isSignSucess = false;
          $scope.docSign = [];
          $scope.isError = false;
          $scope.errorMessage = '';
          $scope.isSuccess = false;
          $scope.successMessage = '';
          $scope.isScopeEmbed = false;
          $scope.isScopeNoEmbed = false;
          $scope.idDocD4Sign = '';
          $scope.statusDocD4Sign = 0;
          $scope.signerEmail = '';
          $scope.signerName = '';
          $scope.rows = [0];
          $scope.sigerList = [];
          $scope.formData = {};
          $scope.signatories = [];
          $scope.d4SignTokenApi = '';
          $scope.d4SignCriptKey = '';
          $scope.selectedEmailType = [];
          $scope.emailType = [];
          $scope.index = 0;
          $scope.modificationDate = false;
          $scope.isDocSigned = false;
          $scope.doSubmit = false;

          $scope.load = logWrapper(
            load,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.autocomplete = logWrapper(
            autocomplete,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.initSign = logWrapper(
            initSign,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.initDocumentDetails = logWrapper(
            initDocumentDetails,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.addRow = logWrapper(
            addRow,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.scrollElement = logWrapper(
            scrollElement,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.removeRow = logWrapper(
            removeRow,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.checkMail = logWrapper(
            checkMail,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.addValueInput = logWrapper(
            addValueInput,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.prevContext = logWrapper(
            prevContext,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.sendSingers = logWrapper(
            sendSingers,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.updateSignersDocument = logWrapper(
            updateSignersDocument,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.callAlterMail = logWrapper(
            callAlterMail,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.callDeleteMail = logWrapper(
            callDeleteMail,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.IsLoggedUser = logWrapper(
            IsLoggedUser,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.sendSingedDocument = logWrapper(
            sendSingedDocument,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.cancelDocument = logWrapper(
            cancelDocument,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.changeD4SignDetails = logWrapper(
            changeD4SignDetails,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.modifyDocument = logWrapper(
            modifyDocument,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.closeModal = logWrapper(
            closeModal,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.sendSingerSettings = logWrapper(
            sendSingerSettings,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.viewEdit = logWrapper(
            viewEdit,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.closeEdit = logWrapper(
            closeEdit,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.callSignRequest = logWrapper(
            callSignRequest,
            runtimeConstant.isDebugControllersInternals
          );

          $scope.load();
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      logWrapper(run, runtimeConstant.isDebugControllers)();
    },
  ],
};
